
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-fhs",
      function () {
        return require("private-next-pages/about-fhs.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-fhs"])
      });
    }
  